"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterPropsFromPropTypes = exports.filterProps = exports.excludeContextProps = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
var _context = require("../context");

/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which only allows props which aren't present in `propsToFilter`.
 *
 * @param {Array<string>} propsToFilter Array of blacklisted prop names
 */
var filterProps = function filterProps() {
  var propsToFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (prop) {
    return propsToFilter.includes(prop) === false;
  };
};
/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which only allows props which aren't present in `propTypes`.
 *
 * @param {Object<string,*>} propTypes Object where the keys are blacklisted prop names
 * @param {{additionalPropsToFilter: Array<String>, propsToForward: Array<String>}} options
 *    Additional prop names to include or exclude from the filter
 */

exports.filterProps = filterProps;
var filterPropsFromPropTypes = function filterPropsFromPropTypes() {
  var propTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$additionalPropsT = _ref.additionalPropsToFilter,
    additionalPropsToFilter = _ref$additionalPropsT === void 0 ? [] : _ref$additionalPropsT,
    _ref$propsToForward = _ref.propsToForward,
    propsToForward = _ref$propsToForward === void 0 ? [] : _ref$propsToForward,
    _ref$filterInvalidHTM = _ref.filterInvalidHTML,
    filterInvalidHTML = _ref$filterInvalidHTM === void 0 ? false : _ref$filterInvalidHTM;
  var propsToFilter = Object.keys(propTypes).filter(function (prop) {
    return propsToForward.includes(prop) === false;
  });
  var filterFn = filterProps([].concat((0, _toConsumableArray2.default)(propsToFilter), (0, _toConsumableArray2.default)(additionalPropsToFilter)));
  if (!filterInvalidHTML) {
    return filterFn;
  }
  return function (prop) {
    return (0, _isPropValid.default)(prop) && filterFn(prop);
  };
};
/**
 * Returns a function designed to be used with Emotion's `shouldForwardProp`
 * which composes the given `shouldForwardProp` function with a filter to
 * filter out Stencil context props.
 */

exports.filterPropsFromPropTypes = filterPropsFromPropTypes;
var excludeContextProps = function excludeContextProps(filterFn) {
  return function (prop) {
    return filterFn(prop) && !_context.STENCIL_CONTEXT_PROPS.includes(prop);
  };
};
exports.excludeContextProps = excludeContextProps;